import { createFileRoute } from "@tanstack/react-router"
import AIReportPage from "@/app/report/aiReport/page"

export const Route = createFileRoute("/report/ai-report")({
  component: AIReportPage,
})
